<template>
  <v-dialog
    v-model="isSupplierDialogVisible"
    width="100%"
    max-width="600px"
    persistent
  >
    <v-card>
      <v-card-title
        >{{ title }} <v-spacer />
        <v-btn icon flat @click="closeDialog"><v-icon icon="$close" /></v-btn>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" lazy-validation v-model="valid">
          <v-row dense>
            <v-col cols="12" align="center">
              <v-text-field
                label="Наименование поставщика"
                v-model="supplier.name"
                :rules="nameRules"
              ></v-text-field>
            </v-col>
            <v-col cols="12" align="center">
              <v-checkbox
                label="Используется для формирования цены"
                v-model="supplier.forPrice"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" align="center">
              <v-checkbox
                :disabled="mainSupplier && mainSupplier.id !== supplier.id"
                label="Основной поставщик"
                v-model="supplier.isMain"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" align="center">
              <h3>Получение цен поставщика</h3>
              <v-radio-group v-model="supplier.priceReceiveMethod">
                <v-radio label="По API" value="api"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12" v-show="supplier.priceReceiveMethod === 'api'">
              <v-text-field
                label="Адрес API"
                v-model="supplier.supplierApi.apiUrl"
              ></v-text-field>
              <v-text-field
                label="Пользователь API"
                v-model="supplier.supplierApi.apiUser"
              ></v-text-field>
              <v-text-field
                type="password"
                label="Пароль API"
                v-model="supplier.supplierApi.apiPassword"
              ></v-text-field>
              <v-text-field
                label="Токен API(опционально)"
                v-model="supplier.supplierApi.apiToken"
              ></v-text-field>
              <v-select
                :items="modules"
                v-model="supplier.supplierApi.moduleId"
                item-title="name"
                item-value="id"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-spacer />
            <v-col cols="3"
              ><v-btn block @click="create" color="primary"
                >Сохранить</v-btn
              ></v-col
            >
            <v-col cols="3"
              ><v-btn block @click="closeDialog">Отмена</v-btn></v-col
            >
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions class="pt-0"> </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";

import { RepositoryFactory } from "@/repositories/RepositoryFactory";
const SuppliersRepository = RepositoryFactory.get("suppliers");
const ExternalModuleRepository = RepositoryFactory.get("externalModules");
export default {
  data() {
    return {
      title: "Добавить поставщика",
      valid: true,
      supplier: {
        id: 0,
        name: "",
        forPrice: false,
        priceReceiveMethod: "api",
        isActive: true,
        isMain: false,
        supplierApi: {
          id: 0,
          apiUrl: "",
          apiUser: "",
          apiPassword: "",
          apiToken: "",
          moduleId: null,
        },
        modules: [],
      },
      nameRules: [(v) => !!v || "Имя поставщика не может быть пустым"],
    };
  },
  created() {
    this.getModules();
  },
  computed: {
    ...mapGetters(["isSupplierDialogVisible", "mainSupplier"]),
  },
  methods: {
    ...mapMutations(["updateSupplierDialogVisible"]),
    closeDialog() {
      this.updateSupplierDialogVisible(false);
    },
    async create() {
      this.$refs.form.validate();
      if (this.valid) {
        const result = await SuppliersRepository.create(this.supplier);

        if (result) {
          if (result.data.status === "success") {
            this.$emit("update");
            this.clearDialog();
            this.closeDialog();
          }
          await SuppliersRepository.updateMainSupplier();
        }
      }
    },
    async getModules() {
      const result = await ExternalModuleRepository.get();
      if (result) {
        this.modules = result.data;
      }
    },
    clearDialog() {
      this.supplier = {
        id: 0,
        name: "",
        forPrice: false,
        priceReceiveMethod: "",
        isActive: true,
        isMain: false,
        supplierApi: {
          id: 0,
          apiUrl: "",
          apiUser: "",
          apiPassword: "",
          apiToken: "",
          moduleId: null,
        },
        modules: [],
      };
    },
  },
};
</script>
<style scoped>
.v-card-title {
  padding: 0 15px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  text-align: center !important;
}
</style>
